<template>
  <div class="system-config-management">
    <el-card shadow="never" class="animate__animated animate__fadeInUp">
      <div class="filter-card">
        <div class="filter-bar">
          <div class="action-group">
            <el-button type="primary" icon="el-icon-plus" @click="handleAdd">添加配置</el-button>
          </div>
        </div>
      </div>

      <div v-if="error" class="error">{{ error }}</div>
      <el-empty
        v-else-if="!loading && configs.length === 0"
        description="暂无数据"
      />

      <div v-else>
        <el-table
          :data="displayConfigs"
          border
          stripe
          v-loading="loading"
          element-loading-text="正在加载..."
          class="animate__animated animate__fadeIn"
          row-key="id"
        >
          <el-table-column prop="id" label="ID" width="80" align="center" />
          <el-table-column prop="configKey" label="配置键" min-width="160" show-overflow-tooltip />
          <el-table-column label="配置值" min-width="220" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ formatConfigValue(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column prop="description" label="描述" min-width="200" show-overflow-tooltip />
          <el-table-column label="操作" width="200" align="center">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="primary"
                icon="el-icon-edit"
                @click="handleEdit(scope.row)"
              >编辑</el-button>
              <el-button
                size="mini"
                type="danger"
                icon="el-icon-delete"
                style="margin-left: 10px;"
                @click="handleDelete(scope.row.id)"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container">
          <el-pagination
            background
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="pagination.page"
            :page-size="pagination.pageSize"
            :page-sizes="[5, 10, 20, 50]"
            :total="pagination.total"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          />
        </div>
      </div>
    </el-card>

    <!-- 普通编辑 / 新增 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="500px"
      center
      append-to-body
    >
      <el-form :model="form" label-width="90px">
        <el-form-item label="配置键">
          <el-input v-model.trim="form.configKey" :disabled="isEdit" autocomplete="off" placeholder="请输入配置键" />
        </el-form-item>
        <el-form-item label="配置值">
          <el-input v-model.trim="form.configValue" autocomplete="off" placeholder="请输入配置值" />
        </el-form-item>
        <el-form-item label="描述">
          <el-input
            type="textarea"
            :rows="3"
            v-model.trim="form.description"
            autocomplete="off"
            placeholder="请输入描述"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 第三种：七天签到金币 -->
    <el-dialog
      title="七天连续签到每日金币"
      :visible.sync="dayArrayDialogVisible"
      width="480px"
      center
      append-to-body
    >
      <div class="day-array-tip">示例：[10,20,30,40,50,60,70]，按连续签到第 1～7 天填写</div>
      <el-form label-width="64px" class="day-array-form" label-position="right">
        <el-form-item
          v-for="(n, idx) in dayArrayValues"
          :key="'day-' + idx"
          :label="'第' + (idx + 1) + '天'"
        >
          <el-input-number
            v-model="dayArrayValues[idx]"
            :min="0"
            :step="1"
            controls-position="right"
          />
        </el-form-item>
        <el-form-item label="描述" class="day-array-desc">
          <el-input
            type="textarea"
            :rows="2"
            v-model.trim="form.description"
            placeholder="请输入描述"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dayArrayDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmitDayArray">保 存</el-button>
      </span>
    </el-dialog>

    <!-- 提现档位：每档同一行（提多少 + 返多少） -->
    <el-dialog
      title="提现档位（提多少 / 返多少）"
      :visible.sync="tierDialogVisible"
      width="640px"
      custom-class="tier-edit-dialog"
      center
      append-to-body
    >
      <div class="day-array-tip">
        每行一档：提现金额（元）与返还金额（元，固定值，非比例）。
      </div>

      <div class="tier-table">
        <div class="tier-table-head">
          <span class="col-idx">档位</span>
          <span class="col-amount">提多少（元）</span>
          <span class="col-return">返多少（元）</span>
          <span class="col-action">操作</span>
        </div>
        <div
          v-for="(row, idx) in tierRows"
          :key="'tier-' + idx"
          class="tier-table-row"
        >
          <span class="col-idx">第{{ idx + 1 }}档</span>
          <div class="col-amount">
            <el-input-number
              v-model="row.amount"
              :min="0"
              :step="0.1"
              :precision="2"
              controls-position="right"
              size="small"
              class="tier-input"
            />
          </div>
          <div class="col-return">
            <el-input-number
              v-model="row.returnYuan"
              :min="0"
              :step="0.1"
              :precision="2"
              controls-position="right"
              size="small"
              class="tier-input"
            />
          </div>
          <div class="col-action">
            <el-button
              type="text"
              size="small"
              class="tier-remove-btn"
              :disabled="tierRows.length <= 1"
              @click="removeTierRow(idx)"
            >
              删除
            </el-button>
          </div>
        </div>
      </div>

      <div class="tier-actions">
        <el-button size="small" icon="el-icon-plus" plain @click="addTierRow">添加档位</el-button>
      </div>
      <el-form label-width="56px" class="tier-desc-form" size="small">
        <el-form-item label="描述">
          <el-input
            type="textarea"
            :rows="2"
            v-model.trim="tierDescription"
            placeholder="余额提现可选金额与返还金额（元）"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="tierDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmitTiers">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { get, post, put, del, getResponseMessage } from '@/utils/http.js'

const COMMISSION_RATE_KEYS = {
  user: 'user_keep_rate',
  direct: 'direct_inviter_rate',
  indirect: 'indirect_inviter_rate',
  agentL1: 'agent_l1_rate',
  agentL2: 'agent_l2_rate'
}
const ALL_COMMISSION_RATE_KEYS = Object.values(COMMISSION_RATE_KEYS)

const CHECKIN_DAILY_COINS_KEY = 'checkin_daily_coins'
const WITHDRAWAL_AMOUNTS_KEY = 'withdrawal_amounts'
const WITHDRAWAL_RETURN_TIERS_KEY = 'withdrawal_return_tiers'

function emptyDayArray() {
  return [null, null, null, null, null, null, null]
}

function emptyTierRows() {
  return [{ amount: 1, returnYuan: 0 }]
}

export default {
  name: 'SystemConfigManagement',
  data() {
    return {
      loading: false,
      error: '',
      configs: [],

      pagination: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      dialogVisible: false,
      dayArrayDialogVisible: false,
      tierDialogVisible: false,
      isEdit: false,
      form: {
        id: null,
        configKey: '',
        configValue: '',
        description: ''
      },
      dayArrayValues: emptyDayArray(),
      tierRows: emptyTierRows(),
      tierDescription: '',
      amountsConfig: null,
      tiersConfig: null
    }
  },
  computed: {
    dialogTitle() {
      return this.isEdit ? '编辑配置' : '新增配置'
    },
    /** 返还档位挂在 withdrawal_amounts 编辑里，列表不再单独展示 */
    displayConfigs() {
      return (this.configs || []).filter(
        row => row && row.configKey !== WITHDRAWAL_RETURN_TIERS_KEY
      )
    }
  },
  mounted() {
    this.fetchConfigs()
  },
  methods: {
    async fetchConfigs() {
      this.error = ''
      this.loading = true
      try {
        const params = {
          page: this.pagination.page,
          pageSize: this.pagination.pageSize
        }

        const result = await get('/admin/config/page', params)
        const data = result.data || {}
        let records = Array.isArray(data.records) ? data.records.slice() : []
        // 返还档位常不在当前分页：始终走接口拉最新值，避免本地缓存把 returnYuan 盖回 0
        const tiers = await this.fetchConfigByKey(WITHDRAWAL_RETURN_TIERS_KEY)
        if (tiers) {
          const idx = records.findIndex(
            item => item && item.configKey === WITHDRAWAL_RETURN_TIERS_KEY
          )
          if (idx >= 0) {
            records.splice(idx, 1, tiers)
          } else {
            records.push(tiers)
          }
        }
        this.configs = records
        this.pagination.total = data.total || 0
        this.pagination.pageSize = data.pageSize || this.pagination.pageSize
        this.pagination.page = data.page || this.pagination.page
      } catch (e) {
        this.error = e && e.message ? e.message : '请求出现错误'
        this.configs = []
        this.pagination.total = 0
      } finally {
        this.loading = false
      }
    },

    formatConfigValue(row) {
      if (!row) return ''
      if (row.configKey !== WITHDRAWAL_AMOUNTS_KEY) {
        return row.configValue || ''
      }
      const amounts = this.parseAmountList(row.configValue) || []
      const tiersRow = (this.configs || []).find(
        item => item && item.configKey === WITHDRAWAL_RETURN_TIERS_KEY
      )
      const tiers = this.parseTierList(tiersRow && tiersRow.configValue) || []
      const map = {}
      tiers.forEach(item => {
        map[this.amountKey(item.amount)] = item.returnYuan
      })
      if (!amounts.length) {
        return row.configValue || ''
      }
      return amounts
        .map(amount => {
          const yuan = map[this.amountKey(amount)]
          if (yuan == null || yuan <= 0) {
            return amount + '元'
          }
          return amount + '元→返' + yuan + '元'
        })
        .join('，')
    },
    handleCurrentChange(page) {
      this.pagination.page = page
      this.fetchConfigs()
    },
    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.pagination.page = 1
      this.fetchConfigs()
    },
    handleAdd() {
      this.isEdit = false
      this.form = {
        id: null,
        configKey: '',
        configValue: '',
        description: ''
      }
      this.dialogVisible = true
    },
    async handleEdit(row) {
      this.isEdit = true
      const key = row && row.configKey ? String(row.configKey).trim() : ''
      this.form = {
        id: row.id,
        configKey: key,
        configValue: row.configValue,
        description: row.description
      }
      if (key === CHECKIN_DAILY_COINS_KEY) {
        this.loadDayArrayFromValue(row.configValue)
        this.dayArrayDialogVisible = true
        return
      }
      if (key === WITHDRAWAL_AMOUNTS_KEY || key === WITHDRAWAL_RETURN_TIERS_KEY) {
        await this.openTierDialog()
        return
      }
      this.dialogVisible = true
    },
    /** 优先本地列表；打开编辑/保存后请用 fetchConfigByKey 拉最新。 */
    async findConfigByKey(key) {
      const found = (this.configs || []).find(item => item && item.configKey === key)
      if (found) return { ...found }
      return this.fetchConfigByKey(key)
    },
    /** 始终请求接口，避免分页缓存把已保存的 returnYuan 读成旧值 0。 */
    async fetchConfigByKey(key) {
      try {
        const result = await get('/admin/config/page', { configKey: key, page: 1, pageSize: 20 })
        const records = (result.data || {}).records || []
        const exact = records.find(item => item && item.configKey === key)
        return exact ? { ...exact } : null
      } catch (e) {
        return null
      }
    },
    patchLocalConfig(row) {
      if (!row || !row.configKey) return
      const list = Array.isArray(this.configs) ? this.configs.slice() : []
      const idx = list.findIndex(item => item && item.configKey === row.configKey)
      if (idx >= 0) {
        list.splice(idx, 1, { ...list[idx], ...row })
      } else {
        list.push({ ...row })
      }
      this.configs = list
    },
    async openTierDialog() {
      this.amountsConfig = await this.fetchConfigByKey(WITHDRAWAL_AMOUNTS_KEY)
      this.tiersConfig = await this.fetchConfigByKey(WITHDRAWAL_RETURN_TIERS_KEY)
      this.tierRows = this.buildTierRows(
        this.amountsConfig && this.amountsConfig.configValue,
        this.tiersConfig && this.tiersConfig.configValue
      )
      this.tierDescription =
        (this.amountsConfig && this.amountsConfig.description) ||
        '余额提现可选金额列表（单位：元）'
      this.tierDialogVisible = true
    },
    buildTierRows(amountsRaw, tiersRaw) {
      const amountList = this.parseAmountList(amountsRaw) || []
      const tierMap = {}
      const tiers = this.parseTierList(tiersRaw) || []
      tiers.forEach(item => {
        const key = this.amountKey(item.amount)
        tierMap[key] = item.returnYuan
      })
      if (amountList.length) {
        return amountList.map(amount => ({
          amount,
          returnYuan: tierMap[this.amountKey(amount)] != null ? tierMap[this.amountKey(amount)] : 0
        }))
      }
      if (tiers.length) {
        return tiers.map(item => ({
          amount: item.amount,
          returnYuan: item.returnYuan
        }))
      }
      return emptyTierRows()
    },
    amountKey(amount) {
      const n = Number(amount)
      if (!Number.isFinite(n)) return '0.00'
      return (Math.round(n * 100) / 100).toFixed(2)
    },
    parseAmountList(value) {
      try {
        const arr = typeof value === 'string' ? JSON.parse(value) : value
        if (!Array.isArray(arr) || !arr.length) return null
        const list = arr
          .map(n => Number(n))
          .filter(n => Number.isFinite(n) && n >= 0)
          .map(n => Math.round(n * 100) / 100)
        return list.length ? list : null
      } catch (e) {
        return null
      }
    },
    parseTierList(value) {
      try {
        const arr = typeof value === 'string' ? JSON.parse(value) : value
        if (!Array.isArray(arr) || !arr.length) return null
        const list = arr
          .map(item => {
            if (!item || typeof item !== 'object') return null
            const amount = Number(item.amount)
            if (!Number.isFinite(amount) || amount < 0) return null
            let returnYuan = Number(item.returnYuan)
            // 兼容旧字段 returnCoins（金币）→ 元
            if (!Number.isFinite(returnYuan) && item.returnCoins != null) {
              const coins = Number(item.returnCoins)
              returnYuan = Number.isFinite(coins) ? Math.max(0, coins) / 1000 : 0
            }
            if (!Number.isFinite(returnYuan) || returnYuan < 0) {
              returnYuan = 0
            }
            return {
              amount: Math.round(amount * 100) / 100,
              returnYuan: Math.round(returnYuan * 100) / 100
            }
          })
          .filter(Boolean)
        return list.length ? list : null
      } catch (e) {
        return null
      }
    },
    addTierRow() {
      this.tierRows = [...(this.tierRows || []), { amount: 1, returnYuan: 0 }]
    },
    removeTierRow(index) {
      if (!this.tierRows || this.tierRows.length <= 1) return
      const next = this.tierRows.slice()
      next.splice(index, 1)
      this.tierRows = next
    },
    normalizeTierRows() {
      const rows = (this.tierRows || [])
        .map(row => ({
          amount:
            row && row.amount !== null && row.amount !== undefined && row.amount !== ''
              ? Math.round(Number(row.amount) * 100) / 100
              : null,
          returnYuan:
            row && row.returnYuan !== null && row.returnYuan !== undefined && row.returnYuan !== ''
              ? Math.max(0, Math.round(Number(row.returnYuan) * 100) / 100)
              : 0
        }))
        .filter(row => row.amount != null && Number.isFinite(row.amount) && row.amount > 0)
      // 按金额去重，保留后写覆盖
      const map = {}
      rows.forEach(row => {
        map[this.amountKey(row.amount)] = row
      })
      return Object.keys(map)
        .sort((a, b) => Number(a) - Number(b))
        .map(k => map[k])
    },
    async upsertConfig(existing, configKey, configValue, description) {
      const payload = { configKey, configValue, description }
      if (existing && existing.id != null) {
        await put(`/admin/config/${existing.id}`, payload)
        return { ...existing, configValue, description }
      }
      const result = await post('/admin/config', payload)
      const data = (result && result.data) || {}
      return {
        id: data.id,
        configKey,
        configValue,
        description
      }
    },
    async handleSubmitTiers() {
      const rows = this.normalizeTierRows()
      if (!rows.length) {
        this.$message.error('请至少填写一行有效的提现金额')
        return
      }
      const amountsValue = JSON.stringify(rows.map(row => row.amount))
      const tiersValue = JSON.stringify(
        rows.map(row => ({ amount: row.amount, returnYuan: row.returnYuan }))
      )
      try {
        const amountsDesc =
          (this.tierDescription && this.tierDescription.trim()) ||
          (this.amountsConfig && this.amountsConfig.description) ||
          '余额提现可选金额列表（单位：元）'
        this.amountsConfig = await this.upsertConfig(
          this.amountsConfig,
          WITHDRAWAL_AMOUNTS_KEY,
          amountsValue,
          amountsDesc
        )
        this.tiersConfig = await this.upsertConfig(
          this.tiersConfig,
          WITHDRAWAL_RETURN_TIERS_KEY,
          tiersValue,
          (this.tiersConfig && this.tiersConfig.description) ||
            '提现成功返还档位（amount元 + returnYuan元）'
        )
        this.patchLocalConfig(this.amountsConfig)
        this.patchLocalConfig(this.tiersConfig)
        this.tierDialogVisible = false
        this.$message.success('保存成功')
        this.fetchConfigs()
      } catch (e) {
        this.$message.error(e && e.message ? e.message : '保存失败')
      }
    },
    parseDayArray(value) {
      try {
        const arr = typeof value === 'string' ? JSON.parse(value) : value
        if (!Array.isArray(arr) || arr.length === 0) return null
        if (!arr.every(n => n !== null && n !== '' && !Number.isNaN(Number(n)))) return null
        return arr.map(n => Math.max(0, Math.floor(Number(n))))
      } catch (e) {
        return null
      }
    },
    loadDayArrayFromValue(value) {
      const parsed = this.parseDayArray(value)
      if (!parsed) {
        this.dayArrayValues = emptyDayArray()
        return
      }
      const arr = parsed.slice(0, 7)
      while (arr.length < 7) arr.push(null)
      this.dayArrayValues = arr
    },
    buildDayArrayPayload() {
      const arr = (this.dayArrayValues || []).slice(0, 7).map(n => {
        if (n === null || n === undefined || n === '') return 0
        const v = Number(n)
        return Number.isFinite(v) ? Math.max(0, Math.floor(v)) : 0
      })
      while (arr.length < 7) arr.push(0)
      return JSON.stringify(arr)
    },
    async handleSubmitDayArray() {
      const parsed = this.parseDayArray(this.buildDayArrayPayload())
      if (!parsed || parsed.length !== 7) {
        this.$message.error('请填写完整的 7 天签到金币')
        return
      }
      this.form.configValue = this.buildDayArrayPayload()
      if (!this.form.description) {
        this.form.description = '七天连续签到每日金币（JSON数组，长度7）'
      }
      await this.persistForm(() => {
        this.dayArrayDialogVisible = false
      })
    },
    async getCommissionRateMap() {
      const map = {}
      for (const key of ALL_COMMISSION_RATE_KEYS) {
        if (key === this.form.configKey) {
          map[key] = Number(this.form.configValue) || 0
          continue
        }
        const found = this.configs.find(item => item.configKey === key)
        if (found) {
          map[key] = Number(found.configValue) || 0
          continue
        }
        try {
          const result = await get('/admin/config/page', { configKey: key, page: 1, pageSize: 1 })
          const records = (result.data || {}).records || []
          map[key] = records.length ? Number(records[0].configValue) || 0 : 0
        } catch (e) {
          map[key] = 0
        }
      }
      return map
    },
    checkCommissionRateExceeded(rates) {
      const user = rates[COMMISSION_RATE_KEYS.user]
      const direct = rates[COMMISSION_RATE_KEYS.direct]
      const indirect = rates[COMMISSION_RATE_KEYS.indirect]
      const agentL1 = rates[COMMISSION_RATE_KEYS.agentL1]
      const agentL2 = rates[COMMISSION_RATE_KEYS.agentL2]
      const base = user + direct + indirect
      const warnings = []
      const sumL1 = base + agentL1
      const sumL2 = base + agentL2
      if (sumL1 > 100) {
        warnings.push(`用户${user}% + 直推${direct}% + 间推${indirect}% + 一级代理${agentL1}% = ${sumL1}%`)
      }
      if (sumL2 > 100) {
        warnings.push(`用户${user}% + 直推${direct}% + 间推${indirect}% + 二级代理${agentL2}% = ${sumL2}%`)
      }
      return { exceeded: warnings.length > 0, warnings }
    },
    async persistForm(onSuccess) {
      try {
        if (this.isEdit) {
          const payload = {
            configKey: this.form.configKey,
            configValue: this.form.configValue,
            description: this.form.description
          }
          const result = await put(`/admin/config/${this.form.id}`, payload)
          if (typeof onSuccess === 'function') onSuccess()
          else this.dialogVisible = false
          this.$message.success(getResponseMessage(result, '编辑成功'))
        } else {
          const payload = {
            configKey: this.form.configKey,
            configValue: this.form.configValue,
            description: this.form.description
          }
          const result = await post('/admin/config', payload)
          if (typeof onSuccess === 'function') onSuccess()
          else this.dialogVisible = false
          this.$message.success(getResponseMessage(result, '添加成功'))
        }
        this.fetchConfigs()
      } catch (e) {
        this.$message.error(e && e.message ? e.message : '操作失败')
      }
    },
    async handleSubmit() {
      if (!this.form.configKey) {
        this.$message.error('配置键不能为空')
        return
      }
      if (!this.form.configValue && this.form.configValue !== 0) {
        this.$message.error('配置值不能为空')
        return
      }
      if (ALL_COMMISSION_RATE_KEYS.includes(this.form.configKey)) {
        const rates = await this.getCommissionRateMap()
        const { exceeded, warnings } = this.checkCommissionRateExceeded(rates)
        if (exceeded) {
          try {
            await this.$confirm(
              `分佣比例合计超过100%：\n${warnings.join('\n')}\n\n继续保存可能导致平台无剩余收益，是否仍要保存？`,
              '分佣比例警告',
              {
                confirmButtonText: '仍要保存',
                cancelButtonText: '取消',
                type: 'warning'
              }
            )
          } catch (e) {
            return
          }
        }
      }
      await this.persistForm()
    },
    async handleDelete(id) {
      try {
        await this.$confirm('确定要删除该配置吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        const result = await del(`/admin/config/${id}`)
        this.$message.success(getResponseMessage(result, '删除成功'))
        if (this.configs.length === 1 && this.pagination.page > 1) {
          this.pagination.page -= 1
        }
        this.fetchConfigs()
      } catch (e) {
        if (e !== 'cancel') {
          this.$message.error(e && e.message ? e.message : '删除失败')
        }
      }
    }
  }
}
</script>

<style scoped>
.system-config-management {
}

.error {
  color: #f87171;
  background: rgba(239, 68, 68, 0.15);
  border: 1px solid rgba(239, 68, 68, 0.3);
  padding: 8px 10px;
  border-radius: 6px;
  margin-bottom: 12px;
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}

.filter-card {
  margin-bottom: 20px;
}

.day-array-tip {
  color: #909399;
  font-size: 12px;
  margin-bottom: 12px;
  line-height: 1.5;
}

.day-array-form .el-form-item {
  margin-bottom: 12px;
}

.day-array-form .el-form-item__label {
  color: #606266;
  font-size: 13px;
}

/* 多行描述：标签与文本框顶部对齐，避免相对中间悬空 */
.day-array-desc {
  margin-bottom: 0;
}

.day-array-desc >>> .el-form-item__label {
  line-height: 1.5;
  padding-top: 8px;
}

.tier-table {
  border: 1px solid #ebeef5;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
}

.tier-table-head,
.tier-table-row {
  display: grid;
  grid-template-columns: 64px 1fr 1fr 56px;
  align-items: center;
  column-gap: 12px;
  padding: 0 12px;
  min-height: 44px;
  box-sizing: border-box;
}

.tier-table-head {
  background: #f5f7fa;
  color: #909399;
  font-size: 12px;
  font-weight: 500;
  border-bottom: 1px solid #ebeef5;
}

.tier-table-row {
  border-bottom: 1px solid #f0f2f5;
}

.tier-table-row:last-child {
  border-bottom: none;
}

.tier-table-row:hover {
  background: #fafbfc;
}

.col-idx {
  color: #606266;
  font-size: 13px;
  white-space: nowrap;
}

.col-amount,
.col-return {
  display: flex;
  align-items: center;
  min-width: 0;
}

.col-action {
  text-align: center;
}

.tier-input {
  width: 100%;
}

.tier-input >>> .el-input-number {
  width: 100%;
}

.tier-input >>> .el-input__inner {
  text-align: left;
  padding-left: 10px;
  padding-right: 40px;
}

.tier-remove-btn {
  color: #f56c6c;
  padding: 0;
}

.tier-remove-btn.is-disabled {
  color: #c0c4cc;
}

.tier-actions {
  margin-top: 12px;
  margin-bottom: 4px;
}

.tier-desc-form {
  margin-top: 12px;
}

.tier-desc-form >>> .el-form-item {
  margin-bottom: 0;
}

.el-card.animate__animated,
.el-table.animate__animated {
  --animate-duration: 0.3s;
}

.el-dialog.animate__zoomIn {
  --animate-duration: 0s;
}
</style>

<style>
.tier-edit-dialog .el-dialog__body {
  max-height: 70vh;
  overflow-y: auto;
  padding-top: 12px;
  padding-bottom: 8px;
}

.tier-edit-dialog .tier-input.el-input-number {
  width: 100%;
}

@media (max-width: 680px) {
  .tier-edit-dialog {
    width: 96% !important;
  }

  .tier-table-head,
  .tier-table-row {
    grid-template-columns: 52px 1fr 1fr 48px;
    column-gap: 8px;
    padding: 0 8px;
  }
}
</style>
